import { apiInstance } from '@/api'
import { AbilityContext, ability } from '@/lib/permissions'
import { theme } from '@/lib/theme'
import { queryClient } from '@/store/queryClient'
import { ApiInstanceProvider, QueryClientProvider } from '@eigtech/ui-shared-api'
import { Auth0ProviderWithHistory } from '@eigtech/ui-shared-auth-web'
import { DaveProvider, extendTheme } from '@eigtech/ui-shared-dave'
import { EigMeetingsLogger, MeetingStateProvider } from '@eigtech/ui-shared-meetings'
import { RoutesProvider } from '@eigtech/ui-shared-router'
import { Toaster } from '@eigtech/ui/components/sonner'
import { LoggerProvider } from 'amazon-chime-sdk-component-library-react'
import { useWhiteLabelChakraColors } from '@eigtech/ui-shared-white-label-web'
import { ReactNode, useMemo } from 'react'
import { IconContext } from 'react-icons'
import { ROUTES_CONTEXT } from '../../../lib/constants'
import { log } from '../../../lib/log'

const meetingLog = log.getLogger('claimDetailMeeting')
meetingLog.setDefaultLevel(import.meta.env.PROD ? 'silent' : 'info')

const logger = new EigMeetingsLogger(meetingLog)

/**
 * Pre Auth Providers are imported above the App.tsx level in main.tsx
 */
export function PreAuthProviders({ children }: { children: ReactNode }) {
  // The white label colors are loaded by the root route's loader, above this
  // provider, and layered over the app's static theme here.
  const whiteLabelColors = useWhiteLabelChakraColors()
  const appTheme = useMemo(
    () => (whiteLabelColors ? extendTheme(theme, { colors: whiteLabelColors }) : theme),
    [whiteLabelColors]
  )

  return (
    <LoggerProvider logger={logger}>
      <MeetingStateProvider canScreenshot>
        <DaveProvider theme={appTheme}>
          <IconContext.Provider value={{ style: { fontSize: '1.25em' } }}>
            <AbilityContext.Provider value={ability}>
              <RoutesProvider routes={ROUTES_CONTEXT}>
                <Auth0ProviderWithHistory>
                  <ApiInstanceProvider instance={apiInstance}>
                    <QueryClientProvider client={queryClient}>
                      {children}

                      <Toaster richColors />
                    </QueryClientProvider>
                  </ApiInstanceProvider>
                </Auth0ProviderWithHistory>
              </RoutesProvider>
            </AbilityContext.Provider>
          </IconContext.Provider>
        </DaveProvider>
      </MeetingStateProvider>
    </LoggerProvider>
  )
}
